import { render, staticRenderFns } from "./InstallationContactsList.vue?vue&type=template&id=a56b79e8&"
import script from "./InstallationContactsList.vue?vue&type=script&lang=js&"
export * from "./InstallationContactsList.vue?vue&type=script&lang=js&"
import style0 from "./InstallationContactsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports